import React, { useEffect } from 'react';
import style from './changePasswordForm.module.scss';
import Input from 'tailwind-components/Input/Input';
import Button from 'tailwind-components/Button/Button';
import PropTypes from 'prop-types';
import useChangePassword from '../useChangePassword';
import { useDispatch } from 'react-redux';
import { REFRESH_USER, SHOW_ALERT } from 'constants/types';
import { getUser } from 'services/user';

function ChangePasswordForm({
  userCredentials = null,
  setResolver = null,
  setUserCredentials = null,
  setVerificationId = null,
  setPhoneNumber = null
}) {
  const dispatch = useDispatch();

  const {
    loading,
    errors,
    newPassword,
    repeatNewPassword,
    passwordChanged,
    setNewPassword,
    setRepeatNewPassword,
    changePassword,
    needsReauthentication
  } = useChangePassword();

  async function endFlow() {
    if (passwordChanged) {
      try {
        const userData = await getUser(userCredentials);
        dispatch({
          type: REFRESH_USER,
          payload: { ...userData.data.zohoData, Portal_Password: newPassword }
        });
        dispatch({
          type: SHOW_ALERT,
          payload: {
            message: 'Password Updated Successfully',
            code: 'success'
          }
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  useEffect(() => {
    endFlow();
  }, [passwordChanged]);

  useEffect(() => {
    if (needsReauthentication) {
      setResolver(null);
      setUserCredentials(null);
      setVerificationId('');
      setPhoneNumber('');
    }
  }, [needsReauthentication]);

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        changePassword();
      }}
      className={style.genericForm}
    >
      <Input
        name='newPassword'
        label='New Password'
        type='password'
        error={errors.newPassword}
        placeholder='Enter your new password'
        onChange={e => setNewPassword(e.target.value)}
        value={newPassword}
      />
      <Input
        name='repeatNewPassword'
        label='Confirm New Password'
        type='password'
        error={errors.repeatNewPassword}
        placeholder='Confirm Your Password'
        onChange={e => setRepeatNewPassword(e.target.value)}
        value={repeatNewPassword}
      />
      <Button
        text='Change password'
        fill
        variant='primaryLight'
        isLoading={loading}
        type='submit'
        className='mt-4'
      />
    </form>
  );
}

ChangePasswordForm.propTypes = {
  userCredentials: PropTypes.object,
  setResolver: PropTypes.func,
  setUserCredentials: PropTypes.func,
  setVerificationId: PropTypes.func,
  setPhoneNumber: PropTypes.func
};

export default ChangePasswordForm;
